import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as ChartTooltip, ResponsiveContainer } from 'recharts';
import type { ChartTheme, SubcontractorDatum } from '../types';
import { DASHBOARD_LABELS as LABELS } from '../../../utils/labels';

interface SubcontractorChartProps {
  data: SubcontractorDatum[];
  chartTheme: ChartTheme;
  isDark: boolean;
}

export default function SubcontractorChart({ data, chartTheme, isDark }: SubcontractorChartProps) {
  const { chartTextColor, gridColor, tooltipStyle } = chartTheme;

  return (
    <ResponsiveContainer width="100%" height={data.length > 6 ? 320 : 260}>
      <BarChart
        data={data}
        margin={{
          top: 4,
          right: 16,
          left: 4,
          bottom: data.length > 6 ? 56 : 16,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} vertical={false} />
        <XAxis
          dataKey="name"
          tick={{
            fill: chartTextColor,
            fontSize: 11,
            angle: data.length > 6 ? -35 : 0,
            textAnchor: data.length > 6 ? 'end' : 'middle',
          }}
          axisLine={false}
          tickLine={false}
          interval={0}
          tickFormatter={(v: string) => (v.length > 16 ? v.slice(0, 15) + '…' : v)}
        />
        <YAxis
          tick={{ fill: chartTextColor, fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
        />
        <ChartTooltip
          contentStyle={tooltipStyle}
          formatter={(value: number) => [`${value} ${LABELS.bookings.toLowerCase()}`, '']}
          separator=""
        />
        <Bar
          dataKey="boekingen"
          fill={isDark ? '#a8b4ff' : '#2243d0'}
          radius={[4, 4, 0, 0]}
          maxBarSize={40}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
